import { Component, Input, OnInit } from '@angular/core';
import { CartaPorteView } from 'src/app/modules/traceability/consult-traceability/view-waybill-traceability/view-waybill-traceability.component';

@Component({
	selector: 'app-waybill-view',
	templateUrl: './waybill-view.component.html',
	styleUrls: ['./waybill-view.component.scss']
})
export class WaybillViewComponent implements OnInit {
	@Input() data: CartaPorteView;

	ngOnInit(): void {
		if (this.data.descripcionPlantaOrigen && this.data.numeroPlantaOrigen) {
			this.data.rucaOrigen =
				this.data.numeroPlantaOrigen +
				' - ' +
				this.data.descripcionPlantaOrigen;
		}
		if (this.data.descripcionPlantaDestino && this.data.numeroPlantaDestino) {
			this.data.rucaDestino =
				this.data.numeroPlantaDestino +
				' - ' +
				this.data.descripcionPlantaDestino;
		}
	}
}
